// src/components/Loader.js
import React from 'react';
import '../App.css'; 
const Loader = () => {
  return (
    <div className="loader_wrapper">
      <div className="loader_logo">Luxe Sparkle</div>
    </div>
  );
};

export default Loader;
